export enum FieldNames {
	Email = 'email',
}

export type FormValuesType = {
	[FieldNames.Email]: string
}
